import SpotlightConstants from '@/utils/enums/spotlightConstants';

const ProtectionBase = () => import('@/modules/spotlight/components/categories/protection/ProtectionBase.vue');
const MechanicalBreakdown = () =>
  import('@/modules/spotlight/components/categories/protection/MechanicalBreakdown.vue');
const PlatinumShield = () => import('@/modules/spotlight/components/categories/protection/PlatinumShield.vue');
const ProtectionProductInformation = () =>
  import('@/modules/spotlight/components/categories/protection/ProtectionProductInformation.vue');
const ProtectionProductVideos = () =>
  import('@/modules/spotlight/components/categories/protection/ProtectionProductVideos.vue');
const ProtectionProductBrochure = () =>
  import('@/modules/spotlight/components/categories/protection/ProtectionProductBrochure.vue');
const protectionSpotlightsVendorProducts = [];

// TODO: make this list dynamic
const protectionSpotlights = [
  SpotlightConstants.internalNames.autoverify['VEHICLE-SERVICE-CONTRACTS'],
  SpotlightConstants.internalNames.autoverify['PREPAID-MAINTENANCE-PLANS'],
  SpotlightConstants.internalNames.autoverify['GAP-INSURANCE'],
  SpotlightConstants.internalNames.autoverify['TIRE-WHEEL-PLAN'],
  SpotlightConstants.internalNames.autoverify['INTERIOR-EXTERIOR-PLANS'],
  SpotlightConstants.internalNames.walkaway.walkaway,
];

Object.keys(SpotlightConstants.internalNames.vendors).forEach(vendor =>
  protectionSpotlightsVendorProducts.push(...Object.values(SpotlightConstants.internalNames.vendors[vendor]))
);

const protectionRoutes = protectionSpotlights.map(protection => ({
  path: protection,
  component: ProtectionBase,
  meta: {
    headerIcon: 'back',
    product: 'Spotlight',
    productInformationPage: true,
    category: SpotlightConstants.categories.PROTECTION,
    headerStyleClasses: 'mb-0',
  },
}));
const protectionVendorProductRoutes = protectionSpotlightsVendorProducts.reduce((routeArray, product) => {
  routeArray.push(
    {
      path: product,
      component: ProtectionProductInformation,
      meta: {
        headerIcon: 'back',
        product: 'Spotlight',
        category: SpotlightConstants.categories.PROTECTION,
        headerStyleClasses: 'mb-0',
      },
    },
    {
      path: `${product}/media-library`,
      component: ProtectionProductVideos,
      meta: {
        headerIcon: 'back',
        product: 'Spotlight',
        category: SpotlightConstants.categories.PROTECTION,
        headerStyleClasses: 'mb-0',
      },
    },
    {
      path: `${product}/programs-and-details`,
      component: ProtectionProductBrochure,
      meta: {
        headerIcon: 'back',
        product: 'Spotlight',
        category: SpotlightConstants.categories.PROTECTION,
        headerStyleClasses: 'mb-0',
      },
    }
  );
  return routeArray;
}, []);

export default [
  ...protectionRoutes,
  ...protectionVendorProductRoutes,
  {
    path: SpotlightConstants.internalNames.firstCanadian.PLATINUM,
    component: PlatinumShield,
    meta: {
      headerIcon: 'back',
      product: 'Spotlight',
      productInformationPage: true,
      category: SpotlightConstants.categories.PROTECTION,
      headerStyleClasses: 'mb-0',
    },
  },
  {
    path: SpotlightConstants.internalNames.firstCanadian.BREAKDOWN,
    component: MechanicalBreakdown,
    meta: {
      headerIcon: 'back',
      product: 'Spotlight',
      productInformationPage: true,
      category: SpotlightConstants.categories.PROTECTION,
      isHero: true,
      headerStyleClasses: 'mb-0',
    },
  },
  {
    path: 'error',
    redirect: '../error',
  },
];
